import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Row, Col, FloatingLabel } from 'react-bootstrap';
import Select from 'react-select';
import PropTypes from 'prop-types';
import CurrencyInput from '../common/CurrencyInput';
import DirectoryService from '../directory/DirectoryService';
import PayrollService from './PayrollService';
const EmployeePaymentModal = ({ isOpen, setOpenModal, identifier }) => {
  const [formData, setFormData] = useState();
  const [isDark, setIsDark] = useState(true);
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);

  const handleClose = () => {
    setOpenModal(false);
  };
  const handleSubmit = () => {
    PayrollService.saveEmployeePayment(formData)
      .then(() => {
        setOpenModal(false);
        setValidated(true);
      })
      .catch(error => {
        setError(error.message);
        setNoDataToShow(false);
      });
  };
  useEffect(() => {
    console.log(error);
    setIsDark(true);
    //console.log("EmployeePaymentModal: ", identifier);
    if (undefined !== identifier) {
      setFormData({
        identifier: identifier,
        status: 'Pending',
        taxCode: 'TAX123',
        fiscalYear: '2023',
        amount: 1200.0
      });

      DirectoryService.retrieveProfile(identifier)
        .then(data => {
          setFormData({
            profileIdentifier: identifier,
            contractIdentifier: data.contract.identifier,
            contractType: data.contract.contractType,
            amount: data.contract.grossSalary,
            taxCode: data.contract.taxCode,
            identifier:
              data.contract?.payments.length > 0
                ? data.contract.payments[0].identifier
                : undefined,
            fiscalYear: '2025',
            status: data.status || 'Pending',
            employeeName: data.firstName + ' ' + data.lastName,
            bg:
              data.status === 'Paid'
                ? 'success'
                : data.status === 'Pending'
                ? 'warning'
                : 'red'
          });
          console.log(formData);
        })
        .catch(error => {
          setError(error.message);
          setNoDataToShow(false);
        });
      setNoDataToShow(false);
    }
  }, [identifier]);
  return (
    <>
      {!noDataToShow && (
        <Form
          className="mb-2"
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
        >
          <Modal show={isOpen} onHide={handleClose} contentClassName="border">
            <Modal.Header
              closeButton
              closeVariant={isDark ? 'white' : undefined}
              className="bg-light px-card border-bottom-0"
            >
              <Modal.Title as="h5">
                {'Payment for ' + formData.employeeName}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row key={'taxCode'}>
                <Col xs={5} sm={4}>
                  <p className="fw-semi-bold mb-1">{'Tax Code: '}</p>
                </Col>
                <Col>{formData.taxCode}</Col>
              </Row>
              <Row key={'fiscalYear'}>
                <Col xs={5} sm={4}>
                  <p className="fw-semi-bold mb-1">{'Fiscal Year: '}</p>
                </Col>
                <Col>{formData.fiscalYear}</Col>
              </Row>
              <Row key={'status'}>
                <Col>
                  <Form.Group className="mb-3" controlId={'status'}>
                    <Form.Label className="fs--1">{'Status'}</Form.Label>
                    <Select
                      closeMenuOnSelect={false}
                      name={'status'}
                      key={'status'}
                      options={[
                        { value: 'Pending', label: 'Pending' },
                        { value: 'Paid', label: 'Paid' },
                        { value: 'Rejected', label: 'Rejected' }
                      ]}
                      placeholder="Select..."
                      required={true}
                      isMulti={false}
                      classNamePrefix="react-select"
                      value={formData['status'] || ''}
                      onChange={value => {
                        setFormData({ ...formData, status: value });
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row key={'amount'}>
                <Col>
                  <Form.Group controlId="amount">
                    <FloatingLabel label={'Amount'} className="mb-2">
                      <CurrencyInput
                        id={'amount'}
                        name={'amount'}
                        value={formData.amount}
                        placeholder="Enter amount"
                        onChange={value => {
                          setFormData({ ...formData, amount: value });
                        }}
                        disabled={false}
                      />
                    </FloatingLabel>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light px-card border-top-0">
              <Button
                variant="primary"
                type="submit"
                onClick={handleSubmit}
                className="px-4 mx-0"
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        </Form>
      )}
    </>
  );
};
EmployeePaymentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  identifier: PropTypes.string.isRequired
};
export default EmployeePaymentModal;
